// extracted by mini-css-extract-plugin
module.exports = {"colorsSelector":"ColorsSelector_colorsSelector__roWxg","colorsList":"ColorsSelector_colorsList__laIgK","label":"ColorsSelector_label__52wJk","link":"ColorsSelector_link__oi7Wc"};